import { WHATSAPP_PHONE, WHATSAPP_DEFAULT_MESSAGE } from '../lib/config';

export const isMobile = (): boolean => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 700;
  }
  return true;
};

export const orderBy = <T extends Record<string, any>>(
  datos: T[],
  campo: keyof T,
  orden: 'asc' | 'desc'
): T[] => {
  if (orden === 'asc') {
    return datos.sort((a, b) => {
      if (a[campo] < b[campo]) return -1;
      if (a[campo] > b[campo]) return 1;
      return 0;
    });
  }

  if (orden === 'desc') {
    return datos.sort((a, b) => {
      if (b[campo] < a[campo]) return -1;
      if (b[campo] > a[campo]) return 1;
      return 0;
    });
  }

  return datos;
};

export const currency = (price?: string | number): string | number | undefined => {
  if (price !== undefined && price.toString() !== '' && !isNaN(Number(price))) {
    let priceStr = price.toString();
    let fort = priceStr.split(' ');
    let currType = '';
    let minus = '';

    if (fort.length > 1) {
      priceStr = fort[1];
      currType = fort[0] + ' ';
    } else {
      priceStr = fort[0];
    }

    if (priceStr.substring(0, 1) === '-') {
      minus = priceStr.substring(0, 1);
      priceStr = priceStr.substring(1);
    }

    const fixed = Number(priceStr).toFixed(2);
    const num2 = fixed.split('.');
    const thousands = num2[0].split('').reverse().join('').match(/.{1,3}/g)!.join('.');
    const decimals = num2[1] ? ',' + (num2[1].length < 2 ? num2[1] + '0' : num2[1]) : '';
    const answer = thousands.split('').reverse().join('') + decimals;

    return currType + minus + answer;
  }

  return price;
};

export const validateEmail = (email: string): boolean => {
  const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
};

export const validatePassword = (pass: string): string[] => {
  const errores: string[] = [];

  if (!/[A-Z]/.test(pass)) {
    errores.push('Ingresá una mayúscula');
  }

  if (pass.length < 8) {
    errores.push('Mínimo 8 caracteres');
  }

  if (!/\d/.test(pass)) {
    errores.push('Ingresá un número');
  }

  return errores;
};

export const malasPalabras = (texto: string): boolean => {
  const list = [' bolud'];
  return list.some((v) => texto.toLowerCase().includes(v));
};

export const toBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(';');
  const cookie = cookies.find((c) => c.trim().startsWith(`${name}=`));
  if (cookie) {
    return cookie.split('=')[1];
  }
  return null;
};

export const decodeBase64 = async (data: string): Promise<any> => {
  let decodedData;
  try {
    decodedData = JSON.parse(Buffer.from(data, 'base64').toString('ascii'));
  } catch {
    // ignore malformed payloads
  }
  return decodedData;
};

export const getWhatsappLink = (message: string = WHATSAPP_DEFAULT_MESSAGE): string =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(message)}`;

// Strapi solo genera `formats` (thumbnail/small/medium/large) para imágenes
// subidas después de migrar a R2 — las cargadas antes por FTP no lo tienen,
// por eso el fallback final a la url original. La card de producto se ve a
// 272x342px CSS, que en pantallas retina (2x) son ~544x684px reales: "small"
// (tope 500px de lado mayor) queda corto, por eso el orden empieza en "medium"
// (tope 750px) en vez de "small". Deliberadamente NO cae a `formats.thumbnail`
// (tope 245px, pensado para el ícono de 60x60 del carrito) — se ve peor que
// mostrar directamente la foto original en tamaño completo.
export const getFotoProductoUrl = (foto: any): string | undefined =>
  foto?.attributes?.formats?.medium?.url ||
  foto?.attributes?.formats?.small?.url ||
  foto?.attributes?.url;
